import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { CuentaBeneficiario } from 'src/app/dashboard/interfaces/cuenta-beneficiario.interface';
import { AccountRecipientService } from 'src/app/dashboard/services/account-recipient.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { DialogBeneficiariosComponent } from './dialog-beneficiarios/dialog-beneficiarios.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountListComponent implements OnInit, OnDestroy {
  usuarioID: number | undefined;
  @Output() reloadAccountList: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<CuentaBeneficiario> = new EventEmitter();
  @Output() seleccion: EventEmitter<CuentaBeneficiario> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  @Input() listaCuentas: CuentaBeneficiario[] = [];

  @Input() seleccionable: boolean = false;
  cuentaSeleccionada: CuentaBeneficiario | undefined;

  displayedColumns: string[] = ['nombre', 'banco', 'tipoCuenta', 'numeroCuenta', 'acciones'];
  expandedCardId: number | null = null;

  constructor(
    private accountRecipientService: AccountRecipientService,
    private spinner: SpinnerService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleCard(id: number | undefined): void {
    if (!id) return;
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  verCuenta(cuenta: CuentaBeneficiario): void {
    const isMobile = window.innerWidth < 768;
    this.dialog.open(DialogBeneficiariosComponent, {
      data: cuenta,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '560px',
      minWidth: isMobile ? '90vw' : '500px',
      maxHeight: '90vh',
    });
  }

  async inactivarCuenta(cuenta: CuentaBeneficiario): Promise<void> {
    if (!cuenta || !cuenta.cuentaBeneficiarioID) return;
    const result = await Swal.fire({
      title: '¿Está seguro de que desea desvincular esta cuenta?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      confirmButtonColor: '#1e5a3f',
    });
    if (result.isDenied || !result.isConfirmed) return;

    const spinnerRef = this.spinner.start();
    try {
      await this.accountRecipientService.inactivateAccount(cuenta.cuentaBeneficiarioID);
      this.snackBar.open('Cuenta eliminada correctamente', '', {
        duration: 2500,
        horizontalPosition: 'end',
        verticalPosition: 'top',
        panelClass: ['aguacate-snackbar'],
      });
      this.reloadAccountList.emit();
    } catch (error) {}
    this.spinner.stop(spinnerRef);
  }

  actualizar(cuenta: CuentaBeneficiario): void {
    this.actualizarCuenta.emit(cuenta);
  }

  eliminarCuenta(): void {
    this.reloadAccountList.emit();
  }

  seleccionar(cuenta: any): void {
    if (!this.seleccionable) return;
    if (this.cuentaSeleccionada && this.cuentaSeleccionada?.cuentaBeneficiarioID !== cuenta.cuentaBeneficiarioID) {
      this.cuentaSeleccionada.seleccionado = false;
    }
    cuenta['seleccionado'] = cuenta['seleccionado'] ? !cuenta['seleccionado'] : true;
    if (cuenta.seleccionado) {
      this.cuentaSeleccionada = cuenta;
      this.seleccion.emit(cuenta);
    } else {
      this.seleccion.emit(undefined);
      this.cuentaSeleccionada = undefined;
    }
  }
}
